import React from 'react';
import { Navigate } from 'react-router-dom';
import { canManageInstitutionAccess, readStoredUser } from '@/auth/saasSession';

export default function InstitutionAccessRoute({ children }) {
  return canManageInstitutionAccess(readStoredUser()) ? children : <Navigate to="/dashboard" replace />;
}
